module.exports = __webpack_public_path__ + "media/images/icons/icon-download-65578c396f0dd8f5ea8b516f97df5899.svg";